module.exports = __webpack_public_path__ + "static/media/015.b2ac3659.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/015.jpg
// module id = 488
// module chunks = 0